import React from "react";
import ComingSoon from "../../components/ComingSoon";
import usePageSeo from "../../hooks/usePageSeo";
import { getComingSoonConfig } from "../../constants/comingSoonRoutes";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/coming_soon.scss";

const DEFAULT_CONFIG = getComingSoonConfig("welcome");

/**
 * Standalone Coming Soon page (no header/footer) with SEO.
 * Pass `pageKey` to load a registry entry, or override individual props.
 */
export default function ComingSoonPage({
  pageKey = "welcome",
  title,
  description,
  featureName,
  badgeLabel,
  illustration,
  primaryButton = null,
  secondaryButton = null,
  seo,
}) {
  const config = getComingSoonConfig(pageKey) || DEFAULT_CONFIG;
  const resolvedSeo = seo || config?.seo || {
    title: "Coming Soon | Trocanet",
    description: "This feature is currently under development and will be available soon.",
  };

  usePageSeo(resolvedSeo);

  return (
    <div className="coming-soon-page">
      <main className="coming-soon-page__main">
        <ComingSoon
          title={title ?? config?.title}
          description={description ?? config?.description}
          featureName={featureName ?? config?.featureName}
          badgeLabel={badgeLabel}
          illustration={illustration}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
        />
      </main>
    </div>
  );
}
